"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenesysDevIcons = exports.GenesysDevIcon = void 0;
var GenesysDevIcon_1 = require("./GenesysDevIcon");
Object.defineProperty(exports, "GenesysDevIcon", { enumerable: true, get: function () { return __importDefault(GenesysDevIcon_1).default; } });
var genesys_dev_icons_1 = require("./resources/genesys-dev-icons");
Object.defineProperty(exports, "GenesysDevIcons", { enumerable: true, get: function () { return genesys_dev_icons_1.GenesysDevIcons; } });
